import {
  IonModal,
} from "@ionic/react";
import { useRef, useState } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import "./CropImage.css";
import { useDebounceEffect } from "./useDebounceEffect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCheck, faCropSimple } from "@fortawesome/pro-light-svg-icons";

const CropPng = (props) => {
  const previewCanvasRef = useRef(null);
  const imgRef = useRef(null);
  const [crop, setCrop] = useState({
    unit: "%",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
  });
  const [completedCrop, setCompletedCrop] = useState({
    unit: "%",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
  });
  const [scale] = useState(1);
  const [rotate] = useState(0);

  function onImageLoad(e) {
    imgRef.current = e.currentTarget;
  }

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
      }
    },
    100,
    [completedCrop, scale, rotate]
  );

  const fitToContainer = (imageWidth, imageHeight) => {
    const canvasScroll = document.getElementById("canvasScroll");
    
    if (!canvasScroll) {
      console.warn("canvasScroll element not found, using fallback dimensions");
      return [imageWidth, imageHeight];
    }
    
    const containerWidth = canvasScroll.offsetWidth || window.innerWidth - 200;
    const containerHeight = canvasScroll.offsetHeight || window.innerHeight - 200;

    var scaledImageHeight = imageHeight;
    var scaledImageWidth = imageWidth;

    let scale = Math.min(
      containerWidth / imageWidth,
      containerHeight / imageHeight
    );

    if (scale < 1) {
      console.log("true");
      scaledImageHeight = Math.floor(imageHeight * scale);
      scaledImageWidth = Math.floor(imageWidth * scale);
      props.setScale(scale);
      console.log("the scale is: ", scale);
    }

    return [scaledImageWidth, scaledImageHeight];
  };

  const handleApplyCrop = () => {
    const img = new Image();
    img.onload = function () {
      console.log("completedCrop: ", completedCrop);
      const newCrop = {
        unit: "px",
        x: img.width * (completedCrop.x / 100),
        y: img.height * (completedCrop.y / 100),
        width: img.width * (completedCrop.width / 100),
        height: img.height * (completedCrop.height / 100),
      };
      props.setCropGlobal(newCrop);
      const canvas = document.getElementById("canvas");
      if (canvas) {
        const [imgWidth, imgHeight] = fitToContainer(
          newCrop.width,
          newCrop.height
        );
        canvas.width = imgWidth;
        canvas.height = imgHeight;
        const ctx = canvas.getContext("2d");
        if (ctx) {
          ctx.drawImage(
            img,
            newCrop.x,
            newCrop.y,
            newCrop.width,
            newCrop.height,
            0,
            0,
            imgWidth,
            imgHeight
          );
        }
      }
      props.setImageDimensions([newCrop.width, newCrop.height]);
      props.setIsModalVisible(false);
    };
    console.log("props.file: ", props.file);
    img.src = `${props.file}`;
  };

  return (
    <div className="test">
      <IonModal
        id="example-modal"
        style={{
          "--height": "85vh",
          "--width": "90vw",
          "--max-width": "1164px",
          "--border-radius": "14px",
        }}
        isOpen={props.isModalVisible}
        onDidDismiss={() => props.setIsModalVisible(false)}
      >
        {/* Custom header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "12px 16px",
            backgroundColor: "#fff",
            borderBottom: "1px solid rgba(0,0,0,0.06)",
          }}
        >
          {/* Cancel */}
          <button
            onClick={() => props.setIsModalVisible(false)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              background: "none",
              border: "1px solid rgba(0,0,0,0.1)",
              borderRadius: "8px",
              padding: "6px 12px",
              fontFamily: "Clash Grotesk",
              fontSize: "12px",
              fontWeight: 500,
              color: "#64748b",
              cursor: "pointer",
              transition: "all 0.15s",
            }}
          >
            <FontAwesomeIcon icon={faXmark} style={{ fontSize: "13px" }} />
            Cancel
          </button>

          {/* Title */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontFamily: "Clash Grotesk",
              fontSize: "14px",
              fontWeight: 600,
              color: "#1e293b",
            }}
          >
            <FontAwesomeIcon icon={faCropSimple} style={{ fontSize: "14px", color: "#94a3b8" }} />
            Crop Image
          </div>

          {/* Apply */}
          <button
            onClick={handleApplyCrop}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              background: "linear-gradient(135deg, #e83e8c 0%, #d63384 100%)",
              border: "none",
              borderRadius: "8px",
              padding: "6px 14px",
              fontFamily: "Clash Grotesk",
              fontSize: "12px",
              fontWeight: 600,
              color: "#fff",
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(232, 62, 140, 0.3)",
              transition: "all 0.15s",
            }}
          >
            <FontAwesomeIcon icon={faCheck} style={{ fontSize: "12px" }} />
            Apply
          </button>
        </div>

        {/* Crop content */}
        <div
          id="contentid"
          style={{
            flex: 1,
            overflow: "hidden",
            backgroundColor: "#f1f3f5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
          }}
        >
          {Boolean(`${props.file}`) && (
            <div
              id="imageBackground"
              style={{
                backgroundColor: "#7f7f7f",
                padding: "10px",
                paddingBottom: "5px",
                borderRadius: "4px",
                maxWidth: "100%",
                maxHeight: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ReactCrop
                crop={crop}
                ruleOfThirds={true}
                onChange={(_, percentCrop) => {
                  setCrop(percentCrop);
                }}
                onComplete={(c, percentCrop) => {
                  setCompletedCrop(percentCrop);
                }}
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              >
                <img
                  id="cropRefImage"
                  alt="Crop me"
                  src={`${props.file}`}
                  onLoad={onImageLoad}
                  onError={() =>
                    console.error("Failed to load image:", props.file)
                  }
                  style={{
                    maxWidth: "100%",
                    maxHeight: "calc(85vh - 90px)",
                    objectFit: "contain",
                  }}
                />
              </ReactCrop>
            </div>
          )}
        </div>
      </IonModal>
    </div>
  );
};

export default CropPng;
